import React from 'react';
import { Container, Typography, Box, Paper, Grid } from '@mui/material';
import { AssignmentReturn, AccountBalanceWallet } from '@mui/icons-material';

const RefundPolicy = () => {
  const policies = [
    {
      icon: <AssignmentReturn sx={{ fontSize: 40, color: 'primary.main' }} />,
      title: "1. Order Confirmation",
      content: [
        "Orders are processed immediately after confirmation",
        "No cancellations are allowed after placing the order."
      ]
    },
    {
      icon: <AccountBalanceWallet sx={{ fontSize: 40, color: 'primary.main' }} />,
      title: "2. Refunds",
      content: [
        "No refunds will be processed once the order is placed successfully.",
        "Refunds will be processed only in case the payment is received twice for the same order",
        "Refunds will be processed within 7–10 working days once initiated."
      ]
    }
  ];

  return (
    <Box sx={{ bgcolor: '#fafafa', py: 10, minHeight: '80vh' }}>
      <Container maxWidth="lg">
        <Box sx={{ mb: 8, textAlign: 'center' }}>
          <Typography variant="h3" component="h1" gutterBottom fontWeight="bold" color="primary">
            Refund & Cancellation Policy – Uniform Orders
          </Typography>
          <Typography variant="h6" color="text.secondary" sx={{ maxWidth: 700, mx: 'auto', mt: 2 }}>
            Please review our policies regarding order confirmations and refunds.
          </Typography>
        </Box>

        <Grid container spacing={4} justifyContent="center">
          {policies.map((policy, index) => (
            <Grid item xs={12} md={6} key={index}>
              <Paper 
                elevation={2} 
                sx={{ 
                  p: 4, 
                  height: '100%', 
                  borderRadius: 4, 
                  display: 'flex', 
                  flexDirection: 'column',
                  alignItems: 'center',
                  transition: '0.3s',
                  '&:hover': { elevation: 8, transform: 'translateY(-5px)' }
                }}
              >
                <Box sx={{ mb: 3, bgcolor: 'rgba(13, 110, 253, 0.05)', p: 2, borderRadius: '50%' }}>
                  {policy.icon}
                </Box>
                <Typography variant="h5" gutterBottom fontWeight="bold" sx={{ mb: 3 }}>
                  {policy.title}
                </Typography>
                <Box sx={{ width: '100%' }}>
                  {policy.content.map((item, i) => (
                    <Typography key={i} variant="body1" color="text.secondary" sx={{ mb: 2, display: 'flex', alignItems: 'flex-start' }}>
                      <Box component="span" sx={{ mr: 2, color: 'primary.main', fontWeight: 'bold' }}>•</Box>
                      {item}
                    </Typography>
                  ))}
                </Box>
              </Paper>
            </Grid>
          ))}
        </Grid>

        <Box sx={{ mt: 6, textAlign: 'center' }}>
          <Typography variant="body1" color="text.secondary">
            Have a specific issue with your order? Reach out to us at <Typography component="span" fontWeight="bold" color="primary">support@thathvauniforms.com</Typography>
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default RefundPolicy;
